import React from 'react'
import ResetPassword from './../components/Login/ResetPassword';

const ResetPage = () => {
  return (
    <div>
      < ResetPassword/>
    </div>
  )
}

export default ResetPage
